import { __decorate, __param } from 'tslib';
import { EventEmitter, ElementRef, Inject, Renderer2, Input, Output, HostListener, Directive, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
let TuiCheckedDirective = class TuiCheckedDirective {
    constructor(element, renderer) {
        this.element = element;
        this.renderer = renderer;
        this.tuiCheckedChange = new EventEmitter();
        this.updateProperty('checked', false);
    }
    set tuiChecked(checked) {
        this.updateProperty('checked', checked || false);
        this.updateProperty('indeterminate', checked === null);
    }
    onChange({ checked }) {
        this.updateProperty('indeterminate', false);
        this.tuiCheckedChange.emit(checked);
    }
    updateProperty(property, value) {
        this.renderer.setProperty(this.element.nativeElement, property, value);
    }
};
TuiCheckedDirective.ɵfac = function TuiCheckedDirective_Factory(t) { return new (t || TuiCheckedDirective)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(Renderer2)); };
TuiCheckedDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiCheckedDirective, selectors: [["input", "tuiChecked", ""], ["input", "tuiCheckedChange", ""]], hostBindings: function TuiCheckedDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("change", function TuiCheckedDirective_change_HostBindingHandler($event) { return ctx.onChange($event.target); });
    } }, inputs: { tuiChecked: "tuiChecked" }, outputs: { tuiCheckedChange: "tuiCheckedChange" } });
TuiCheckedDirective.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: Renderer2, decorators: [{ type: Inject, args: [Renderer2,] }] }
];
__decorate([
    Input()
], TuiCheckedDirective.prototype, "tuiChecked", null);
__decorate([
    Output()
], TuiCheckedDirective.prototype, "tuiCheckedChange", void 0);
__decorate([
    HostListener('change', ['$event.target'])
], TuiCheckedDirective.prototype, "onChange", null);
TuiCheckedDirective = __decorate([ __param(0, Inject(ElementRef)),
    __param(1, Inject(Renderer2))
], TuiCheckedDirective);

let TuiCheckedModule = class TuiCheckedModule {
};
TuiCheckedModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiCheckedModule });
TuiCheckedModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiCheckedModule_Factory(t) { return new (t || TuiCheckedModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiCheckedDirective, [{
        type: Directive,
        args: [{
                selector: 'input[tuiChecked], input[tuiCheckedChange]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc0.Renderer2, decorators: [{
                type: Inject,
                args: [Renderer2]
            }] }]; }, { tuiCheckedChange: [{
            type: Output
        }], tuiChecked: [{
            type: Input
        }], onChange: [{
            type: HostListener,
            args: ['change', ['$event.target']]
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiCheckedModule, { declarations: [TuiCheckedDirective], exports: [TuiCheckedDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiCheckedModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiCheckedDirective],
                exports: [TuiCheckedDirective]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiCheckedDirective, TuiCheckedModule };

//# sourceMappingURL=taiga-ui-cdk-directives-checked.js.map